/** postMessage types exchanged with the Zoho Desk userscript. */
export enum SupportPanelMessageType {
  READY = 'focusbear:support-panel:ready',
  TICKET = 'focusbear:support-panel:ticket'
}

export enum SupportCustomerLookupOutcome {
  FOUND = 'found',
  NOT_FOUND = 'not_found',
  MULTIPLE_MATCHES = 'multiple_matches',
  NO_CONTACT_EMAIL = 'no_contact_email',
  TICKET_NOT_FOUND = 'ticket_not_found'
}

/** The service the API names in a 503 when a lookup could not finish. */
export enum SupportPanelUnavailableService {
  ZOHO_DESK = 'zoho_desk',
  AUTH0 = 'auth0'
}

export enum SupportPanelStatus {
  WAITING_FOR_TICKET = 'waiting_for_ticket',
  LOADING = 'loading',
  FOUND = 'found',
  NOT_FOUND = 'not_found',
  MULTIPLE_MATCHES = 'multiple_matches',
  NO_CONTACT_EMAIL = 'no_contact_email',
  TICKET_NOT_FOUND = 'ticket_not_found',
  NOT_AUTHORISED = 'not_authorised',
  UNAVAILABLE = 'unavailable',
  ZOHO_UNAVAILABLE = 'zoho_unavailable',
  AUTH0_UNAVAILABLE = 'auth0_unavailable'
}

/** BE contract: how many subscriptions on the customer's record still give access. */
export enum SupportSubscriptionSummary {
  NO_RECORD = 'no_record',
  NONE_ACTIVE = 'none_active',
  ONE_ACTIVE = 'one_active',
  SEVERAL_ACTIVE = 'several_active'
}

export enum SupportSubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  BILLING_ISSUE = 'billing_issue',
  EXPIRED = 'expired'
}

/** BE contract: RevenueCat period types that mean the store has not charged full price yet. */
export enum SupportSubscriptionPeriodType {
  TRIAL = 'trial',
  INTRO = 'intro'
}

/** BE contract: RevenueCat's ownership type when another account pays. */
export enum SupportSubscriptionOwnershipType {
  FAMILY_SHARED = 'FAMILY_SHARED'
}

/** BE contract: the sensitive action an action token is issued for. */
export enum SupportOperation {
  CANCEL_SUBSCRIPTION = 'cancel_subscription'
}

/** BE contract: the fixed reasons an agent may give for a cancellation. */
export enum SupportCancellationReason {
  CUSTOMER_REQUEST = 'customer_request',
  DUPLICATE_SUBSCRIPTION = 'duplicate_subscription',
  BILLING_ERROR = 'billing_error',
  OTHER = 'other'
}

/** BE contract: what happened to the subscription. */
export enum SupportCancellationOutcome {
  CANCELLED = 'cancelled',
  ALREADY_CANCELLED = 'already_cancelled',
  NO_SUBSCRIPTION = 'no_subscription',
  SEVERAL_SUBSCRIPTIONS = 'several_subscriptions',
  UNSUPPORTED_CHANNEL = 'unsupported_channel',
  TEAM_PLAN = 'team_plan',
  PROVIDER_FAILED = 'provider_failed'
}

export enum SupportCancellationStep {
  IDLE = 'idle',
  PREPARING = 'preparing',
  CONFIRMING = 'confirming',
  SUBMITTING = 'submitting',
  DONE = 'done',
  FAILED = 'failed'
}

/** Why a cancellation did not go through, as far as the API's status code says. */
export enum SupportCancellationFailure {
  EXPIRED = 'expired',
  CHANGED = 'changed',
  NOT_AUTHORISED = 'not_authorised',
  CUSTOMER_NOT_FOUND = 'customer_not_found',
  UNAVAILABLE = 'unavailable'
}
